export const LEDGER_SOURCE = {
  Insurance: "Insurance",
  Client: "Self-Pay",
  Practice: "Practice",
  Other: "Other",
} as const;

export type LedgerSource = (typeof LEDGER_SOURCE)[keyof typeof LEDGER_SOURCE];

export const LEDGER_SOURCE_OPTIONS = [
  { value: LEDGER_SOURCE.Insurance, label: LEDGER_SOURCE.Insurance },
  { value: LEDGER_SOURCE.Client, label: LEDGER_SOURCE.Client },
  { value: LEDGER_SOURCE.Other, label: LEDGER_SOURCE.Other },
] as const;

const LEDGER_SOURCES = new Set<string>(Object.values(LEDGER_SOURCE));

export function isLedgerSource(value: unknown): value is LedgerSource {
  return typeof value === "string" && LEDGER_SOURCES.has(value);
}
